import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const CarbonReporterBase = styled.div`
  padding: 24px;
  border: 2px solid ${theme.colors.blues[50]};
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  ${theme.largerThan.xl} {
    padding: 36px 48px;
    flex-direction: row;
  }
`;

export const Description = styled.div`
  flex: 2;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.darkBlues[75]};

  ${theme.largerThan.xl} {
    margin-right: 36px;
  }
`;

export const Reports = styled.div`
  flex: 3;
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${theme.largerThan.md} {
    flex-direction: row;
  }

  ${theme.largerThan.xl} {
    flex-direction: column;
  }
`;

export const Report = styled.div`
  background: ${theme.colors.blues[5]};
  padding: 12px 16px 12px 13px;
  color: ${theme.colors.blues[100]};
  border-radius: 14px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;

  &:first-of-type {
    margin-bottom: 12px;
  }

  ${theme.largerThan.md} {
    padding: 21px 24px;

    &:first-of-type {
      margin-right: 12px;
      margin-bottom: 0;
    }
  }

  ${theme.largerThan.xl} {
    flex-wrap: nowrap;
    flex: none;

    &:first-of-type {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }
`;

export const Icon = styled.i`
  color: ${theme.colors.darkBlues[25]};
  font-size: 27px;
  line-height: 32px;
  min-width: 40px;

  ${theme.largerThan.sm} {
    font-size: 36px;
    line-height: 44px;
    min-width: 54px;
  }
`;

export const Amount = styled.span`
  font-size: 27px;
  line-height: 32px;
  margin-right: 12px;

  ${theme.largerThan.sm} {
    font-size: 36px;
    line-height: 44px;
    flex: 2;
    margin-right: 12px;
  }
`;

export const Units = styled.div`
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  flex-basis: 100%;

  ${theme.largerThan.sm} {
    font-size: 16px;
    line-height: 22px;
    margin-top: 0px;
    height: fit-content;
    align-self: center;
  }

  ${theme.largerThan.xl} {
    flex-basis: initial;
    text-align: right;
  }
`;
